/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_InspectionInputs */

const en_orders_inspection = /** @type {(inputs: Orders_InspectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspection`)
};

const es_orders_inspection = /** @type {(inputs: Orders_InspectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspeccion`)
};

/**
* | output |
* | --- |
* | "Inspection" |
*
* @param {Orders_InspectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_inspection = /** @type {((inputs?: Orders_InspectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_InspectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_inspection(inputs)
	return es_orders_inspection(inputs)
});